export enum MeetingCheckInSteps {
  meetingCode = 0,
  attendeeCheckIn = 1,
  attendeeRegistration = 2
}